<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />

    <v-container>
      <div class="pt-3 mt-sm-20">
        <v-row>
          <v-col md="7" lg="7" sm="12" class="rowtext">
            <div>
              <h3>
                Unlock Instant Access to Maritime Knowledge with AI-Powered
                Document Search
              </h3>
              <p class="pt-2">
                Effortlessly search across your company's unstructured data -
                from PDF manuals to scanned documents - with our cutting-edge
                generative AI solution, specifically designed for the marine
                industry.
              </p>
            </div>
            <template>
              <v-row>
                <v-col
                  v-for="(feature, i) in features"
                  :key="i"
                  cols="12"
                  md="12"
                  lg="12"
                  xl="12"
                >
                  <base-avatar-card v-bind="feature" align="left" horizontal />
                </v-col>
              </v-row>
            </template>

            <div>
              <p><b>Why Choose Our AI-Powered System?</b></p>
            </div>

            <div class="texv">
              <v-icon color="indigo darken-4" x-large>
                mdi mdi-clock-outline </v-icon
              >&nbsp; Save valuable time with instant, on-demand knowledge
              access. <br /><br />
              <v-icon color="indigo darken-4" x-large>
                mdi mdi-magnify-minus-outline </v-icon
              >&nbsp; Improve crew efficiency by reducing manual searches.
              <br /><br />
              <v-icon color="indigo darken-4" x-large>
                mdi mdi-shield-lock-outline</v-icon
              >&nbsp; Ensure data privacy with secure, cloud-hosted solutions.
              <br /><br />
              <v-icon color="indigo darken-4" x-large> mdi-cog</v-icon>&nbsp;
              Integrate effortlessly with your existing ERP systems.
              <br /><br />
              <v-icon color="indigo darken-4" x-large>
                mdi mdi-arrow-decision</v-icon
              >&nbsp; Affordable, flexible licensing that fits your business
              needs.
            </div>
            <div class="pt-3">
              <p>
                <b>Transform Your Maritime Operations</b> Discover the future of
                maritime document management and empower your crew with
                AI-driven insights. Contact us today to schedule a demo and see
                how our solution can revolutionize your operations.
              </p>
            </div>
          </v-col>
          <v-col md="5" lg="5" sm="12"> <base-request /></v-col>
        </v-row>
        <p class="text-center">
          <strong>
            "A one-size-fits-all approach is not effective for either shoes or
            software. Both need to be tailored to the individual user or
            business to be truly effective."</strong
          >
        </p>
      </div>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "Knowledge Base Software";
  },

  data: () => ({
    features: [
      {
        color: "blue darken-2",
        dark: true,
        title: "AI-Powered Document Chat",
        icon: "mdi-file-document-outline",
        text:
          "Empower your crew onboard with instant answers by allowing each department to upload their documents and interact with them using natural language. From complex operational manuals to regulatory documents, knowledge is now accessible on demand."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Private and Secure Hosting",
        icon: "mdi-server",
        text:
          "Your data stays yours. Host your documents privately with complete control, while providing your teams the power to search through them securely using your corporate domain logins."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Unlimited Access & Queries",
        icon: "mdi-infinity",
        text:
          "Enjoy unlimited user access and unlimited queries at an affordable licensing fee. Our solution is built to scale with your company’s needs, making sure that your entire team has instant access to vital information."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Seamless ERP Integration",
        icon: "mdi-cogs",
        text:
          "Get more from your data with built-in database connectors that integrate directly with your existing ERP systems. Unlock business insights quickly and efficiently by connecting your systems in one unified search platform."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Audit Logs & Role-Based Access Control",
        icon: "mdi-account-key-outline",
        text:
          "Keep track of all interactions with robust audit logging. With built-in role-based access control, you can ensure that the right people access the right information at the right time."
      }
    ]
  })
};
</script>
<style scoped>
.h3 {
  font-size: 30px;
  color: rgb(3, 50, 97);
}
.div-p {
  text-align: center;
}
h1 {
  font-size: 44px;
  color: rgb(3, 50, 97);
  text-align: center;
}
.p-div-class {
  font-size: 20px;
}
.center-div {
  font-size: 25px;
}
.sub-div-class {
  font-size: 17px;
}
.div-list {
  font-size: 18px;
}
.rowtext {
  text-align: justify;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
